import React, { useState } from "react";
import close from "../../../../static/ic-close.svg";
import { withTranslation, Trans } from "react-i18next";
import { connect } from "react-redux";
import { openCloseAboutUs, openCloseOrderHistory } from "../../../../Redux/actions/actionNames";

class App extends React.Component {

  openOrderHistory=()=>{
    this.props.dispatch(openCloseAboutUs(false))
  }

  render() {
    return (
      <div className="OrderListHeader">
        <img onClick={this.openOrderHistory} src={close} className="OrderListHeaderClose" />
        <span className="OrderListHeaderTitle">
          <Trans i18nKey={"Aboutus"}>
          </Trans>
        </span>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(App));
